export enum ElementIds {
  SyncConfigButton = 'app-bottom-action-sync-config-button',
  SaveConfigButton = 'app-bottom-action-save-config-button',
}
